export enum ServicePaymentDropdownHooks {
  Dropdown = 'service-payment-dropdown',
  SingleOptionAsLabelServiceName = 'service-payment-label-service-name',
  SingleOptionAsLabelDescription = 'service-payment-label-description',
}
